"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class List {
    constructor(TNew) {
        this.items = [];
        this.loaded = false;
        this.TNew = TNew;
    }
    reset(raws = []) {
        this.items = raws.map(raw => new this.TNew(raw));
        this.loaded = true;
    }
    all() {
        if (!this.loaded) {
            throw new Error('Trying to access an Anita Options list without being loaded');
        }
        return this.items;
    }
    findById(id) {
        return this.findByField('id', id);
    }
    findByField(field, value) {
        if (value === null)
            return null;
        const item = this.items.find((item) => item[field] === value);
        if (!item)
            return null;
        return item;
    }
}
exports.default = List;
